import request from "utils/request";

export function loadRecentPosts(dataFilters) {
    return request()
        .query(dataFilters)
        .get("/api/v1/recent-posts/")
        .send();
}

export function loadPostFeed(dataFilters) {
    return request()
        .query(dataFilters)
        .get("/api/v1/posts/")
        .send();
}

export function loadFeaturedPosts(dataFilters) {
    return request()
        .query(dataFilters)
        .get("/api/v1/featured-posts/")
        .send();
}

export function loadPostDetails(postId) {
    return request()
        .get(`/api/v1/posts/${postId}/`)
        .send();
}

export function loadPostDetailsWithOutAuth(postId) {
    return request()
        .get(`/api/v1/posts-without-auth/${postId}/`)
        .send();
}

export function followPost(postId) {
    return request()
        .post(`/api/v1/posts/${postId}/follow/`)
        .send();
}

export function likePost(postId) {
    return request()
        .post(`/api/v1/posts/${postId}/like/`)
        .send();
}

export function createPost(post) {
    return request()
        .post("/api/v1/posts/")
        .send(post);
}

export function updatePost(post) {
    return request()
        .patch(`/api/v1/posts/${post.uniqueId}/`)
        .send(post);
}

export function deletePost(postId) {
    return request()
        .delete(`/api/v1/posts/${postId}/`)
        .send();
}

export function loadLikedByUsers(postId) {
    return request()
        .get(`/api/v1/posts/${postId}/likes/`)
        .send();
}

export function copyPost(postData) {
    return request()
        .post("/api/v1/copy-post/")
        .send(postData);
}

export function createTag(tagData) {
    return request()
        .post("/api/v1/tags/")
        .send(tagData);
}
